
import TextScrambler from "@/data/TextScrambler";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Modal",

  data() {
    return {
      headlineScrambler: new TextScrambler("", 1000),
    };
  },

  props: {
    headline: {
      type: String,
      default: "",
    },
  },

  mounted() {
    this.headlineScrambler.word = this.headline;
    this.headlineScrambler.start();
  },

  computed: {
    currentHeadline(): string {
      return this.headlineScrambler.currentWord;
    },
  },

  methods: {
    handleClick(event: Event) {
      if ((event.target as HTMLElement).className == "modal") {
        this.$emit("close");
      }
    },
  },
});
